import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";

const UpdateSimpleMailTemplateModal = (props) => {
    const [historyList, setHistoryList] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {candidateId, isShow, onClose} = props

    const fetchJobSendRequestHistoryList = (canId) => {
        if (!canId) {
            return;
        }
        CandidateService.getJobSendRequestInputHistory(canId).then((res) => {
            setHistoryList(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (isShow) {
            fetchJobSendRequestHistoryList(candidateId)
        }
    }, [isShow]);

    const onCloseModal = () => {
        onClose()
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onCloseModal()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Lịch sử update yêu cầu gửi job</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <table
                            className='table table-bordered table-hover text-center'
                        >
                            <thead>
                            <tr>
                                <th>No.</th>
                                <th>User NL</th>
                                <th>Giá trị NL</th>
                                <th>Thời gian NL</th>
                            </tr>
                            </thead>
                            <tbody>
                            {historyList && historyList.length > 0 && historyList.map((history, index) => (
                                <tr key={`template_${index}`}>
                                    <td>{history.no ? history.no : index + 1}</td>
                                    <td className={"text-truncate"}>{history.username}</td>
                                    <td className={"text-truncate"}>{history.job_send_request}</td>
                                    <td className={"text-truncate"}>{history.updated_date_time}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateSimpleMailTemplateModal;
